{
    "Profile_SecureMyOffer_AdditionalSellers.additionalSellers": "Vendeurs additionnels",
    "Profile_SecureMyOffer_AdditionalSellers.description": "Ajoutez des vendeurs additionnels impliques dans cette transaction immobiliere. Vous pouvez ajouter jusqu'a 3 vendeurs additionnels.",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.newSeller": "Nouveau vendeur",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.sellerDetails": "Details du vendeur",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.firstName": "Prenom",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.lastName": "Nom",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.email": "Courriel",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.phone": "Telephone"
}
